import { OnOffSwitchService } from "../Common/OnOffSwitchConfigurations/OnOffSwitchService";
export class RopConfigService extends OnOffSwitchService {
    constructor() {
        super();
    }
    GetServiceName() {
        return RopConfigService.ServiceName;
    }
}
RopConfigService.ServiceName = "RopConfigService";
//# sourceMappingURL=RopConfigService.js.map